import React from 'react';
import { cn } from '../../utils/cn';
import { StockCategoryFilter, CategoryHelpers } from '../../types/stockCategories';

interface CompanyInfoCardsProps {
  sector?: string;
  category?: StockCategoryFilter;
  showCategoryBadge?: boolean;
  className?: string;
}

export const CompanyInfoCards: React.FC<CompanyInfoCardsProps> = ({
  sector = "FINANCIAL SERVICES",
  category,
  showCategoryBadge = true,
  className
}) => {
  const categoryConfig = category ? CategoryHelpers.getConfig(category) : null;

  // Don't render anything if there's no visible content
  if (!showCategoryBadge || !categoryConfig) {
    return null;
  }

  return (
    <div className={cn("w-full text-center space-y-2", className)}>
      {/* Category Badge */}
      <div className="flex items-center justify-center gap-2 mb-2">
        <div
          className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-sm font-medium text-white shadow-sm"
          style={{ backgroundColor: categoryConfig.color }}
        >
          <span role="img" aria-label={categoryConfig.label}>
            {categoryConfig.icon}
          </span>
          <span>{categoryConfig.label}</span>
        </div>
      </div>
    </div>
  );
};

export default CompanyInfoCards;